import { render, staticRenderFns } from "./chart-details-dialog.vue?vue&type=template&id=2446c48a"
import script from "./chart-details-dialog.vue?vue&type=script&lang=js"
export * from "./chart-details-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports